function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Immutable from 'seamless-immutable';
import { indexOf, is, slice, without } from 'ramda';
import { getNextStepIndex, getPreviousStepIndex } from './wizard.helper';
export default (function (allStepsKeys) {
  return {
    initialState: Immutable({
      currentStepIndex: 0,
      completedSteps: _defineProperty({}, allStepsKeys[0], allStepsKeys[0]),
      currentStepIsInvalid: false,
      selectedTabIndex: 0,
      skippedSteps: []
    }),
    goToNextStep: function goToNextStep(state) {
      if (state.currentStepIndex !== allStepsKeys.length - 1) {
        return state.merge({
          previousStepIndex: state.currentStepIndex,
          currentStepIndex: getNextStepIndex(allStepsKeys, state.skippedSteps, state.currentStepIndex),
          currentStepIsInvalid: false,
          completedSteps: state.completedSteps.merge(_defineProperty({}, allStepsKeys[state.currentStepIndex], allStepsKeys[state.currentStepIndex]))
        }, {
          deep: true
        });
      }
      return state;
    },
    goToPreviousStep: function goToPreviousStep(state) {
      var destinationStepIndex = getPreviousStepIndex(allStepsKeys, state.completedSteps, state.currentStepIndex);
      var skippedStepsBeforeDestinationStep = [];
      if (null !== destinationStepIndex) {
        skippedStepsBeforeDestinationStep = state.skippedSteps.filter(function (skippedStepKey) {
          var skippedStepIndex = allStepsKeys.findIndex(function (allStepKey) {
            return allStepKey === skippedStepKey;
          });
          return -1 !== skippedStepIndex ? destinationStepIndex > skippedStepIndex : false;
        });
      }
      return state.merge({
        previousStepIndex: state.currentStepIndex,
        currentStepIndex: destinationStepIndex,
        currentStepIsInvalid: false,
        skippedSteps: skippedStepsBeforeDestinationStep
      }, {
        deep: true
      });
    },
    goToStep: function goToStep(state, payload) {
      var destinationStepKey = is(Array, payload) ? payload[0] : payload;
      var shouldSkipCurrentStep = is(Array, payload) ? payload[1] : false;
      var destinationStepIndex = indexOf(destinationStepKey, allStepsKeys);
      if (destinationStepIndex - state.currentStepIndex > 0) {
        var startSkipIndex = shouldSkipCurrentStep ? state.currentStepIndex : state.currentStepIndex + 1;
        var skippedSteps = slice(startSkipIndex, destinationStepIndex, allStepsKeys);
        var completedSteps = shouldSkipCurrentStep ? state.completedSteps.without(allStepsKeys[state.currentStepIndex]) : state.completedSteps.merge(_defineProperty({}, allStepsKeys[state.currentStepIndex], allStepsKeys[state.currentStepIndex]));
        completedSteps = without(skippedSteps, completedSteps);
        return state.merge({
          currentStepIndex: destinationStepIndex,
          currentStepIsInvalid: false,
          skippedSteps: skippedSteps,
          completedSteps: completedSteps
        });
      } else if (destinationStepIndex !== -1) {
        return state.merge({
          currentStepIndex: destinationStepIndex,
          currentStepIsInvalid: false
        });
      }
      return state;
    },
    setCurrentStepIsInvalid: function setCurrentStepIsInvalid(state, payload) {
      return state.merge({
        currentStepIsInvalid: payload
      }, {
        deep: true
      });
    },
    setSelectedOrderTab: function setSelectedOrderTab(state, payload) {
      return state.set('selectedTabIndex', payload);
    }
  };
});